import { z } from "zod";
import { recordId } from "./contracts";

export const payoutAccountQuery = z.object({ actingOrganization: recordId.toLowerCase() });
export type PayoutAccountQuery = z.infer<typeof payoutAccountQuery>;

export const payoutAccountRequest = z.object({ actingOrganization: recordId.toLowerCase() }).strict();
export type PayoutAccountRequest = z.infer<typeof payoutAccountRequest>;

export const payoutAccount = z.object({
  stripeAccountId: z.string(),
  payoutsEnabled: z.boolean().nullable(),
  detailsSubmitted: z.boolean().nullable(),
  requirementsDue: z.array(z.string()),
  checkedWithStripe: z.boolean(),
  syncedAt: z.string().nullable(),
});
export type PayoutAccount = z.infer<typeof payoutAccount>;

export const payoutAccountState = z.object({ account: payoutAccount.nullable() });
export type PayoutAccountState = z.infer<typeof payoutAccountState>;

export const payoutAccountLink = z.object({ url: z.string().url() });
export type PayoutAccountLink = z.infer<typeof payoutAccountLink>;

export const balanceAmount = z.object({ amount: z.number().int(), currency: z.string() });
export type BalanceAmount = z.infer<typeof balanceAmount>;

export const payoutBalance = z.object({ available: z.array(balanceAmount), pending: z.array(balanceAmount) });
export type PayoutBalance = z.infer<typeof payoutBalance>;
